import { render, staticRenderFns } from "./Pos_page.vue?vue&type=template&id=03bd3778&scoped=true&"
import script from "./Pos_page.vue?vue&type=script&lang=js&"
export * from "./Pos_page.vue?vue&type=script&lang=js&"
import style0 from "./Pos_page.vue?vue&type=style&index=0&id=03bd3778&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bd3778",
  null
  
)

export default component.exports